import Model from './model'

export default class Category extends Model {
  constructor() {
    super()
    this.hydrate({
      title: '',
      slug: '',
      type: ''
    })
  }
}
